import { VPagination } from 'vuetify/lib/components/VPagination';

var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.props.totalPages>1)?_c(VPagination,{attrs:{"length":_vm.props.totalPages,"total-visible":"10","color":"primary"},on:{"input":page => _vm.props.setPage(page)},model:{value:(_vm.props.page),callback:function ($$v) {_vm.$set(_vm.props, "page", $$v)},expression:"props.page"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }